/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

/** ISO date (`YYYY-MM-DD`) recorded at signup / re-acceptance. */
export const POLICY_VERSION_DATE = /^\d{4}-\d{2}-\d{2}$/

/**
 * `min_acceptance_version` sentinel: returning users are not required to re-accept,
 * including accounts with a missing or older stored version.
 */
export const LEGAL_MIN_ACCEPTANCE_DISABLED = 'DISABLE'
